<template>
  <div v-if="Object.keys($store.state.atalhos).length >= 1">
    <div v-if="mostrar === true" class="cpnt-atalho-mascara" @click="mostrar = !mostrar"></div>

    <div :class="mostrar === true ? 'atalho-mostra' : 'atalho-oculta'">
      <div class="atalho-app button-atalho" @click="mostrar = !mostrar">
        <i :key="'nao_mostrar'" class="fas fa-angle-double-left" ></i>

        <span v-if="mostrar === true">&nbsp;Atalhos</span>
      </div>
      <div class="atalho-app conteudo-atalho noselect">
        <table>
          <template v-for="(nome, atalho, atalhoIndex) in $store.state.atalhos" >
            <tr :key="atalhoIndex" v-if="([ '', null, undefined ].indexOf(nome.nome) === -1 && ($store.state.mobile === false) || ($store.state.mobile === true && atalho !== 'ALT+M'))">
              <td style="min-width: 90px; font-size: var(--font-base-soma-10); padding-right: 5px; text-align: right;">
                <table style="width: 100%;">
                  <tr>
                    <template v-for="(button, index) in atalho.split('+')">
                      <td :key="'atalho-' + atalhoIndex + '-td-' + index + '-1'" :style="index === 0 ? 'width: 100%;' : 'width: 30px;'">
                        <!-- <div :style="'width: ' + ([ 'CTRL', 'ALT' ].indexOf(button) !== -1 ? '38px' : '30px')"> -->
                        <div :style="'width: 38px'">
                          <span>{{ button }}</span>
                        </div>                      
                      </td>

                      <td :key="'atalho-' + atalhoIndex + '-td-' + index + '-2'" style="width: 10px;" v-if="(index + 1) < atalho.split('+').length">+</td>
                    </template>
                  </tr>
                </table>
              </td>

              <td style="width: 18px; text-align: center; padding-right: 2px; font-size: var(--font-base-soma-12); padding-right: 5px;">
                <i class="fas fa-arrow-right"></i>
              </td>

              <td v-html="nome.nome" style="width: 100%;" @click="appMostrarConteudoAtalho(atalho)" class="button-atalho-conteudo"></td>
            </tr>
          </template>
        </table>
      </div>
    </div>

    <span v-shortkey="[ 'alt', 'p' ]" @shortkey="appMostrarConteudoAtalho" v-if="$store.state.atalhos.hasOwnProperty('ALT+P')" data-tecla="ALT+P">
      <span v-if="$store.state.atalhos['ALT+P'].mostrar === true">{{ appMostrarConteudoAtalho('ALT+P', true) }}</span>
    </span>

    <span v-shortkey="[ 'alt', 'c' ]" @shortkey="appMostrarConteudoAtalho" v-if="$store.state.atalhos.hasOwnProperty('ALT+C')" data-tecla="ALT+C">
      <span v-if="$store.state.atalhos['ALT+C'].mostrar === true">{{ appMostrarConteudoAtalho('ALT+C', true) }}</span>
    </span>

    <span v-shortkey="[ 'alt', 'v' ]" @shortkey="appMostrarConteudoAtalho" v-if="$store.state.atalhos.hasOwnProperty('ALT+V')" data-tecla="ALT+V">
      <span v-if="$store.state.atalhos['ALT+V'].mostrar === true">{{ appMostrarConteudoAtalho('ALT+V', true) }}</span>
    </span>

    <span v-shortkey="[ 'alt', 'n' ]" @shortkey="appMostrarConteudoAtalho" v-if="$store.state.atalhos.hasOwnProperty('ALT+N')" data-tecla="ALT+N">
      <span v-if="$store.state.atalhos['ALT+N'].mostrar === true">{{ appMostrarConteudoAtalho('ALT+N', true) }}</span>
    </span>

    <span v-shortkey="[ 'alt', 's' ]" @shortkey="appMostrarConteudoAtalho" v-if="$store.state.atalhos.hasOwnProperty('ALT+S')" data-tecla="ALT+S">
      <span v-if="$store.state.atalhos['ALT+S'].mostrar === true">{{ appMostrarConteudoAtalho('ALT+S', true) }}</span>
    </span>

    <span v-shortkey="[ 'alt', 'r' ]" @shortkey="appMostrarConteudoAtalho" v-if="$store.state.atalhos.hasOwnProperty('ALT+R')" data-tecla="ALT+R">
      <Demanda-Editar-Request-Manual v-if="$store.state.atalhos['ALT+R'].mostrar === true" :cpntVendaAcoesProduto="$store.state.atalhos['ALT+R'].buttons" :cpntRefId="$store.state.atalhos['ALT+R'].refId" :cpntFecharDialog="appMostrarFecharRequestManual"></Demanda-Editar-Request-Manual>
    </span>

    <RF-Compra-Etiqueta v-if="$store.state.gerarEtiqCompra !== ''"></RF-Compra-Etiqueta>
  </div>
</template>

<style scoped>
  .atalho-app {
    background: #fcfcfc;
    box-shadow: -2px 4px 4px 0px rgba(0,0,0,.05);
    border: 1px solid #ccc;
    border-right: 0px;
    position: fixed;
    z-index: 2500;
    padding: 6px 6px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
    .button-atalho {
      top: 96px;
      right: 0px;
      width: 25px;
      cursor: pointer;
    }
      .atalho-mostra > .button-atalho {
        border-bottom: 0px;
        width: 300px;
        height: 31px;
        border-bottom-left-radius: 0px;
      }
      .atalho-oculta > .button-atalho > svg {
        transform: rotate( 0deg );            
        transition: transform 700ms ease;
      }
      .atalho-mostra > .button-atalho > svg {
        transform: rotate( -180deg );            
        transition: transform 700ms ease;
      }
      .atalho-mostra > .button-atalho {
        transition: 700ms;
        width: 300px;
      }
      .atalho-oculta > .button-atalho {
        transition: 700ms;
        width: 25px;
      }
    .conteudo-atalho {
      top: 123px;
      right: 0px;

      width: 300px;
      /* height: 200px; */
      border-top-left-radius: 0px;
      border-bottom-left-radius: 3px;
    }
      .atalho-mostra > .conteudo-atalho {
        transition: 700ms;
        right: 0px;
      }
      .atalho-oculta > .conteudo-atalho {
        transition: 700ms;
        right: -301px;
        /* right: -50px; */
      }
      .conteudo-atalho > table {
        width: 100%;
      }
        .conteudo-atalho > table > tr > td {
          padding: 5px 0px 5px 0px;
        }
          .conteudo-atalho > table > tr > td > table > tr > td > div {
            display: inline-block;
            background: #f2f2f2;
            border: 1px solid #ccc;
            padding: 2px 3px;
            margin: 0px 2px;
            border-radius: 2px;
            text-align: center;
          }
          .conteudo-atalho > table > tr > td > svg {
            color: #7d7d7d;
          }

        .button-atalho-conteudo {
          cursor: pointer;
        }
          .button-atalho-conteudo:hover {
            text-decoration: underline
          }


  .cpnt-atalho-mascara {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 2500;
    height: 100%;
    width: 100%;
  }
</style>

<style>
.scroll-y-hidden > #rotina-facil-web > div > span > .rf-dialog,
.scroll-y-hidden > #rotina-facil-web > div > span > div > .rf-dialog {
  z-index: 3500 !important;
}
</style>

<script>
  export default {
    components: {
      'Demanda-Editar-Request-Manual': () => import('@/components/demanda/Editar/Demanda-Editar-Request-Manual.vue'),
      'RF-Compra-Etiqueta': () => import('@/components/compra/etiqueta/Compra-Etiqueta.vue')
    },
    data: function () {
      return {
        mostrar: false
      }
    },
    methods: {
      appMostrarConteudoAtalho: function (event, forcar = false) {
        // INICIA A VARIAVEL
        var atalho = ''

        // PEGA O ATALHO CLICADO
        if (typeof event === 'object') {
          atalho = event.target.getAttribute('data-tecla')
        } else {
          atalho = event
        }

        // VERIFICA O ATALHO QUE FOI APERTADO
        if ([ 'ALT+N', 'ALT+V', 'ALT+C', 'ALT+P', 'ALT+S' ].indexOf(atalho) !== -1) {
          if (forcar === true || this.$store.state.atalhos[atalho].mostrar === false) {
            // INICIA OS PARAMETRHOS QUE SERÁ ENVIADO
            var params = {}

            // VERIFICA O TIPO DE ABERTURA QUE DEVE REALIZAR
            switch (atalho) {
              case 'ALT+N':
                params = { tipo: 'DEMANDA_NOVA', demanda: 'venda' }
                break

              case 'ALT+V':
                params = { tipo: 'CONSULTAR_DEMANDA', demanda: 'venda' }
                break

              case 'ALT+C':
                params = { tipo: 'CONSULTAR_CONTATO' }
                break

              case 'ALT+P':
                params = { tipo: 'CONSULTAR_PRODUTO' }
                break

              case 'ALT+S':
                params = { tipo: 'SUBASE_SUPORTE' }
                break
            }

            // SETA O CALLBACK PARA FECHAR A JANELA
            params.callback = () => {
              if (this.$store.state.atalhos[atalho].mostrar !== false) {
                // VERIFICA SE JÁ ESTA ABERTO ALGUM CADASTRO
                if (atalho === 'ALT+C' && this.$store.state.infoCadastro !== null && this.$store.state.atalhos['ALT+C'].mostrar === false) {
                  this.$store.commit('SET_ABRIR_CADASTRO', null)
                }
        
                // VERIFICA SE ENCONTRA A TECLA QUE FOI CLICADA
                if ([ '', null, undefined ].indexOf(atalho) === -1) {
                  this.$store.commit('EXECUTE_ATALHO', atalho)
                }
              }
            }

            // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
            this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
          }
        } else {
          // VERIFICA SE JÁ ESTA ABERTO ALGUM CADASTRO
          if (atalho === 'ALT+C' && this.$store.state.infoCadastro !== null && this.$store.state.atalhos['ALT+C'].mostrar === false) {
            this.$store.commit('SET_ABRIR_CADASTRO', null)
          }
  
          // VERIFICA SE ENCONTRA A TECLA QUE FOI CLICADA
          if ([ '', null, undefined ].indexOf(atalho) === -1) {
            this.$store.commit('EXECUTE_ATALHO', atalho)
          }
        }

        // FECHA A OPÇÃO DE ATALHO SE ELA ESTIVER ABERTA
        if (this.mostrar === true) {
          this.mostrar = false
        }
      },
      appMostrarFecharRequestManual: function () {
        this.$store.commit('EXECUTE_ATALHO', 'ALT+R')
      }
    },
    watch: {
      '$route': function () {
        if (this.mostrar === true) {
          this.mostrar = false
        }
      }
    }
  }
</script>
